// Analitica de uso (admin).
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Analítica de uso (admin) ----

export const getMentorAnalytics = () =>
  api.get("/admin/analytics/mentor").then((r) => r.data);
// LAS DUDAS DE LOS ALUMNOS AL MENTOR, con su nombre, la pregunta limpia y la respuesta entera
// (13 oct 2026). Es la vista deliberada de eso: el porqué, en
// `backend/app/modules/analytics/dudas.py`. `alumno` acota a uno.
export const getDudasDeAlumnos = (limite = 60, alumno = "") =>
  api.get("/admin/analytics/dudas", { params: { limite, alumno: alumno || undefined } })
    .then((r) => r.data?.dudas || []);
// LA LISTA Y LA FICHA DE CADA ALUMNO (13 oct 2026). Nombre, correo, notas y dudas de menores:
// solo el panel de admin. El porque de cada dato, en `backend/app/domain/ficha_alumno.py`.
export const getAlumnos = () => api.get("/admin/analytics/alumnos").then((r) => r.data);
export const getFichaDeAlumno = (id) =>
  api.get(`/admin/analytics/alumnos/${encodeURIComponent(id)}`).then((r) => r.data);
// El Excel llega como bytes. El nombre lleva la fecha; se pone aqui porque, con el servidor en
// otro dominio, el navegador no deja leer la cabecera con el nombre si no se expone a proposito.
// Sin correos ni el texto de las dudas: es para comparar, y un fichero sale del panel.
export const descargaExcelDeAlumnos = async () => {
  const r = await api.get("/admin/analytics/alumnos/excel", { responseType: "blob" });
  const cabecera = r.headers?.["content-disposition"] || "";
  const nombre = (cabecera.match(/filename="([^"]+)"/) || [])[1]
    || `alumnos-academia-alpha-${new Date().toISOString().slice(0, 10)}.xlsx`;
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// Dominio por leccion y por modulo (analitica del CMS).
//
// Devuelve datos AGREGADOS: ni un nombre ni un identificador de alumno. Es una vista de
// la leccion —«esta se le atraganta a todo el mundo»— y no de la gente; para eso esta la
// pestaña de Alumnos, que cuelga de otro sitio con otros permisos.
export const adminCursosConDominio = async () =>
  api.get("/admin/analytics/cursos").then((r) => r.data);

export const adminDominioDeCurso = async (courseId) =>
  api.get(`/admin/analytics/dominio/${courseId}`).then((r) => r.data);

// Cuantas cuentas se han creado (admin).
//
// NO ES LO MISMO QUE «Alumnos» de la pestaña de Uso, y por eso esta aparte: aquello cuenta
// quien ha hablado con un mentor. Esto cuenta altas, que es lo que se pregunta cuando se
// pregunta «cuanta gente hay». `desde` recorta el desglose por dia, no el total.
export const adminCuentas = async (desde) =>
  api.get("/admin/analytics/cuentas", { params: desde ? { desde } : {} }).then((r) => r.data);

// La lista de quien se ha dado de alta (admin). Lleva nombre y correo de menores: no se pinta
// en ningun sitio que no sea el panel del equipo. `orden` es "nombre", "apellidos" o "alta".
export const adminAltas = async (orden) =>
  api.get("/admin/analytics/altas", { params: orden ? { orden } : {} }).then((r) => r.data);

/** El recuento de pantallas leido para el mundo 3D: entradas, embudos y sus avisos.
 *  Los avisos vienen DENTRO de la respuesta a proposito: una advertencia que se queda en el
 *  servidor no advierte a nadie. */
export const getMundoAnalytics = (desde) =>
  api.get("/admin/analytics/mundo", { params: desde ? { desde } : {} }).then((r) => r.data);
